angular.module("app.constants", [])

.constant("version", "1.3.4")

;